import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';
import { TranslateService } from '../../../../node_modules/@ngx-translate/core';
import { environment } from '../../../environments/environment';
import { AccessLevel } from '../../common/enums/access-level.enum';
import { Permission } from '../../common/enums/permission.enum';
import { CommonService } from '../../shared/services/common.service';
import { MessageService } from '../../shared/services/message.service';
import { CommonMessage } from '../common/common-messages';
import { MemberOrderType, MemberType, SearchResponseType } from '../common/constants';
import { AccountTypeConstants } from '../constants/account-type.constants';
import { PaymentMethodTypeConstants } from '../constants/payment-method-types.constants';
import { AccountType } from '../enums/echeck-accounttypes.enum';
import { PaymentMethodTypes } from '../enums/order-source-type';
import { PaymentCardTypes } from '../enums/payment-card-types.enum';
import { ShipMethodEnums } from '../enums/shipmethod.enums';
import { AddressInformation } from '../interface/address-detail-info';
import { BillingInformation } from '../interface/billing-info';
import { MemberSearchByFboIdResponse } from '../interface/member-search-by-fboid-response';
import { ProductInformation } from '../interface/product-info';
import { SearchRequest } from '../interface/search-request';
import { ShippingAddressInfoConfig } from '../interface/shipping-address-info-config.interface';
import { ShippingInformation } from '../interface/shipping-info';
import { TaxType } from '../interface/tax-type.interface';
import { DistributorInfo } from '../interface/ticketingsystem/distributor-info';
import { WorkTicket } from '../interface/ticketingsystem/work-ticket';
import { DeleteModal } from '../models/delete-modal';
import { OrderInfoTab } from '../models/order-info-tab-model';
import { SearchSettingsModal } from '../models/searchSettings-modal';
import { TicketTabInfo } from '../models/tickets-tab.model';
import { CustomerService } from '../services/customer.service';
import { OrderService } from '../services/order.service';
import { ShippingAddressInfoConfigService } from '../services/shipping-config.service';
import { TrackingModel } from '../models/tracking-model';
import { MemberTypeEnum } from '../enums/member-type.enum';

@Component({
    selector: 'order-view',
    templateUrl: '../templates/template1/views/order-view.component.html',
    styleUrls: [
        '../templates/template1/themes/default/css/order-view.less'
    ]
})
export class OrderViewComponent implements OnInit {
    @Input() fboid:string;
    @Input() distributorInfo: DistributorInfo;
    @Input() orderInfo: OrderInfoTab;
    isDesc: boolean = false;
    sortColumn: string = "orderDate";
    storeInfo: any;
    webOrderId: String;
    shipTrackingUrl:string;
    orderInformation: any;
    tickets: Array<WorkTicket> = []
    ticketsIsDesc: boolean = false;
    ticketsSort: string = "ASC";
    ticketsSortColumn: string = "ID";
    ticketsPageNumber: number = 1;
    ticketsPageSize: number = 10;
    ticketsPageCount: number = 0;
    isTicketView:boolean;
    isTicketCreate:boolean ;
    deleteModal:DeleteModal;
    paymentType: any = PaymentMethodTypes;
    orderNotes: any[]=[];
    orderLogs: any[]=[];
    ShipMethodEnums = ShipMethodEnums;
    showCCSnapshot:boolean;
    FBOManageTicketPermissions: any[] = [
        Permission.MANAGE_TICKETS_CREATE,
        Permission.MANAGE_DEPARTMENT_TICKETS_ASSIGN,
        Permission.MANAGE_TICKETS_ADD_NOTE_ATTACHMENT,
        Permission.MANAGE_TICKETS_VIEW
    ];
    FBODetailPermissions: any[] = [Permission.FBO_PROFILE_VIEW, Permission.FBO_ORDER_HISTORY_VIEW,
        Permission.FBO_AUTOSHIP_DETAILS_VIEW, Permission.FBO_PAYMENT_METHODS_VIEW,
        Permission.FBO_DOWNLINE_VIEW, Permission.FBO_REPORTS_VIEW, Permission.MANAGE_TICKETS_VIEW];
    paymentMethodTypeConstants:any = PaymentMethodTypeConstants;
    AccountTypeConstants:any = AccountTypeConstants;
    accountTypeEnums = AccountType;
    isOrderLoaded = false;
    gstTax: number;
    pstTax: number;
    isTitan = false;
    searchComponentSettings: SearchSettingsModal;
    isDownlineMemeber = false;
    userInfo: DistributorInfo;
    shippingAddressInfoConfig: ShippingAddressInfoConfig;
    memberTypes = MemberType;
    trackingModel:TrackingModel;
    trackingUrls=[];
    memberTypeEnum = MemberTypeEnum;
    constructor(private _customerservice: CustomerService, private messageService: MessageService, private _commonService:CommonService,
        private _orderService: OrderService,  private _translatePipe: TranslateService,  private _shippingAddressInfoConfigService: ShippingAddressInfoConfigService) {
    }
    ngOnInit(): void {
        this.isRetailUser();
        this.isTicketCreate = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[0] + "]"),AccessLevel.Customer_Service);
        this.isTicketView = this._commonService.checkPermissionByAccessLevel(JSON.parse("[" + this.FBOManageTicketPermissions[3] + "]"),AccessLevel.Customer_Service);
        this.getOrderInformation(this.orderInfo.orderID, this.orderInfo.webOrderID, this.orderInfo.homeCountry);
        this.subscribeDisputeTickets();
        this.deleteModal = new DeleteModal(this.doNotRemoveFormData.bind(this),
        this.doNotRemoveFormData.bind(this), this.doNotRemoveFormData.bind(this));
        this.deleteModal.viewActionButtons = false;
    }

    isRetailUser(): void {
        if (this.orderInfo && this.orderInfo.retailID && this.orderInfo.retailID !== this.distributorInfo.distributorId) {
            this.getDistributorInfo(this.orderInfo.retailID);
            this.isDownlineMemeber = true;
        } else {
            this.userInfo = this.distributorInfo;
        }
        if (this.userInfo && (this.userInfo.level === MemberType.GUEST || this.userInfo.level === MemberType.RETAIL
            || this.userInfo.level === MemberOrderType.RETAIL || this.userInfo.level === MemberType.RETAILCUSTOMER)) {
            this.showCCSnapshot = false;
        } else {
            this.showCCSnapshot = true;
        }
    }
    /**
     * Gets fbo / retail oder information
     */
    getOrderInformation(orderNumber: string, webOrderNumber: string, country: string) {
        this.webOrderId = webOrderNumber;
        this.getShippingTrackURL(this.webOrderId);
        this._customerservice.getOrderInformation(orderNumber, webOrderNumber, country).subscribe(response => {
            if (response) {
                this.isOrderLoaded = false;
                this.orderInformation = response;
                if (this.orderInformation && this.orderInformation.taxMetaData
                    && this.orderInformation.taxMetaData.orderTaxCharges
                    && this.orderInformation.taxMetaData.orderTaxCharges.length > 0) {
                    const gst = this.orderInformation.taxMetaData
                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.GST_TAX);
                    const pst = this.orderInformation.taxMetaData
                        .orderTaxCharges.find(tax => tax.taxChargeType === TaxType.PST_TAX);
                    this.gstTax = gst ? gst.taxAmount : 0;
                    this.pstTax = pst ? pst.taxAmount : 0;
                }
                this.getStoreInfo(this.orderInfo.homeCountry);

                //verifying wether respective fields are undefined or not.. if undefined assigning respective model
                if (!this.orderInformation.billingInfo) {
                    this.orderInformation.billingInfo = new BillingInformation();
                    this.orderInformation.billingInfo.address = new AddressInformation();
                }
                if (!this.orderInformation.shippingInfo) {
                    this.orderInformation.shippingInfo = new ShippingInformation();
                    this.orderInformation.shippingInfo.address = new AddressInformation();
                }
                else if(response.shippingInfo.shippingDate)
                {
                    this.orderInformation.shippingInfo.shippingDate = new Date(response.shippingInfo.shippingDate);

                }
                if (!this.orderInformation.productInfo) {
                    this.orderInformation.productInfo = new Array<ProductInformation>();
                }
                if(this.orderInfo.webOrderID) {
                    this.getOrderPaymentInfo(this.orderInfo.webOrderID);
                    this.getOrderLogs();
                }
                this.getDisputeTickets();
                this.getOrderNotes();
                this.getOrderLogs();
            }
        });
    }

    /**
     * @description  To navigate to Fbo MemberDetails Tab
     * @author Akhil
     * @date 2020-08-27
     * @param {string} id
     * @param {string} memberType
     * @param {string} name
     * @memberof OrderViewComponent
     */
    navigateToFboDetails(userInfo: DistributorInfo): void {
        const isAuthorized = this._commonService.checkPermissionByAccessLevel(this.FBODetailPermissions, AccessLevel.Customer_Service);
        if (isAuthorized) {
            const fboInfo = {
                id: userInfo.distributorId,
                tabName: userInfo.displayName,
                componentName: 'fboPage',
                memberType: userInfo.memberType
            };
            this.messageService.setCustomerServiceTabContent(fboInfo);
        } else {
            this.displayAlertbox();
        }
    }

    /**
     * @description To get MemberDetails from Titan
     * @author Akhil
     * @date 2020-08-27
     * @param {string} memberId
     * @memberof OrderViewComponent
     */
    getDistributorInfo(memberId: string): void {
        if (memberId) {
            this._customerservice.getFBOProfileInfoFromTitan(memberId).subscribe(response => {
                if (response && response.isSuccess) {
                    this.userInfo = response;
                    if (response.firstName && response.lastName) {
                        this.userInfo.name = response.firstName;
                        this.userInfo.displayName = response.firstName + ' ' + response.lastName;
                    }
                    this.userInfo.memberType = response.memberType;
                    this.userInfo.email = response.emailId;
                    this.userInfo.privacyRequested = this._commonService.isPrivacyRequested(response.memberPreferences);
                    if (response.fboId) {
                        this.userInfo.distributorId = response.fboId;
                        this.getMemberLevelInfo(response.fboId);
                    }
                } else {
                    this.getSearchDistributorInfoFromAs400(memberId);
                }
            }, (error: any) => {
                this.getSearchDistributorInfoFromAs400(memberId);
            });
        }
    }

    getMemberLevelInfo(fboId, isAS400?: boolean): void {
      if (isAS400) {
        this.getMemberLevelInformationFromAS400(fboId, this.userInfo.memberType);}

        // this._commonService.getMemberLevelDetails(fboId).subscribe((response) => {
        //     if (response && response.memberLevel) {
        //         this.userInfo.level = response.memberLevel;
        //     } else if (isAS400) {
        //         this.getMemberLevelInformationFromAS400(fboId, this.userInfo.memberType);
        //     }
        // }, (error) => {
        //     if (isAS400) {
        //         this.getMemberLevelInformationFromAS400(fboId, this.userInfo.memberType);
        //     }
        // });
    }

    /**
     * @description to get Member details from AS400
     * @author Akhil
     * @date 2020-08-27
     * @param {string} distributorId
     * @memberof OrderViewComponent
     */
    getSearchDistributorInfoFromAs400(distributorId: string): void {
        this.searchComponentSettings = new SearchSettingsModal(5, 0);
        const searchRequest: SearchRequest = this.prepareMemberByIdRequestForSearch(distributorId);
        this._customerservice.getSearchResults(searchRequest)
            .subscribe((response: MemberSearchByFboIdResponse) => {
                if (response) {
                    if (response.status === SearchResponseType.COMPLETED) {
                        this.searchSuccess(response);
                    } else {
                        this.searchPolling(response, distributorId);
                    }
                }
            }, error => {
                this.searchErrorResponse(error);
            });
    }

    /**
     * @description preparing Search critera
     * @author Akhil
     * @date 2020-08-27
     * @private
     * @param {string} distributorId
     * @returns {SearchRequest}
     * @memberof OrderViewComponent
     */
    private prepareMemberByIdRequestForSearch(distributorId: string): SearchRequest {
        let searchKey: string;
        let searchValue: string;
        if (distributorId) {
            searchKey = 'FBOID';
            searchValue = distributorId;
        }
        const searchRequest: SearchRequest = {
            pageNumber: 1,
            pageSize: 10,
            sort: 'DESC',
            isAdvancedSearch: false,
            searchBy: 'MEMBER',
            sortOrder: ['fboId'],
            searchCriteria: [
                {
                    searchKey: searchKey,
                    searchValue: searchValue
                }
            ]
        };
        return searchRequest;
    }

    /**
     * @description polling request for AS400 member Details
     * @author Akhil
     * @date 2020-08-27
     * @param {*} response
     * @param {string} distributorId
     * @memberof OrderViewComponent
     */
    searchPolling(response: any, distributorId: string) {
        if ((response.status === SearchResponseType.IN_PROGRESS) || (response.status === SearchResponseType.QUEUED)) {
            if (this.searchComponentSettings.pollCount < this.searchComponentSettings.maxPollCount) {
                this.searchComponentSettings.pollCount = this.searchComponentSettings.pollCount + 1;
                this.getSearchDistributorInfoFromAs400(distributorId);
            } else {
                const message: any = this._translatePipe.get('order-view.Member Not Found');
                this._commonService.setNotification('', message.value, 'error', 0, true, 30);
            }
        }
    }

    /**
     * @description As400 Member details Processing
     * @author Akhil
     * @date 2020-08-27
     * @param {*} response
     * @memberof OrderViewComponent
     */
    searchSuccess(response): void {
        if (response && response.fboSearchResultModelList && response.fboSearchResultModelList.length > 0) {
            const fboSearchResultModel = response.fboSearchResultModelList[0];
            if (fboSearchResultModel) {
                this.userInfo = new DistributorInfo();
                this.userInfo.displayName = (fboSearchResultModel.fullName ? fboSearchResultModel.fullName : '') as string;
                this.userInfo.name = this.userInfo.displayName;
                this.userInfo.email = (fboSearchResultModel.email ? fboSearchResultModel.email : '') as string;
                this.userInfo.memberType = (fboSearchResultModel.memberType ? fboSearchResultModel.memberType : '') as string;
                this.userInfo.distributorId = (fboSearchResultModel.fboId ? fboSearchResultModel.fboId : '') as string;
                this.userInfo.privacyRequested = fboSearchResultModel.memberPreferences ?
                    this._commonService.isPrivacyRequested(fboSearchResultModel.memberPreferences) : 'NA';
                if (fboSearchResultModel.memberType) {
                    if (fboSearchResultModel.memberType === MemberType.R) {
                        this.userInfo.level = MemberType.RETAIL;
                    } else if (fboSearchResultModel.memberType === MemberType.G) {
                        this.userInfo.level = MemberType.GUEST;
                    } else {
                        this.getMemberLevelInfo(this.userInfo.distributorId);
                    }
                }
            }
        }
    }

    /**
     * @description Error Response for Member Details
     * @author Akhil
     * @date 2020-08-27
     * @param {*} error
     * @memberof OrderViewComponent
     */
    searchErrorResponse(error: any) {
        if (error.validations && error.validations.length > 0) {
            this._commonService.setNotification('', error.validations[0].message, 'error', 0, true, 30);
        }
    }

    /**
     * @description To get Member Details from As400
     * @author Akhil
     * @date 2020-08-27
     * @param {string} distibutorId
     * @param {string} memberType
     * @memberof OrderViewComponent
     */
    getMemberLevelInformationFromAS400(distibutorId: string, memberType: string): void {
        if (distibutorId) {
            this._customerservice.getFBOProfileInformation(distibutorId, memberType).subscribe(response => {
                if (response && response.success) {
                    this.userInfo.level = response.memberLevel;
                }
            });
        }
    }

    /*
    get Dispute Tickets created on selected web order Id.
     */
    getDisputeTickets() {
        var weborderId = this.webOrderId || this.orderInfo.orderNumber || this.orderInfo.orderID ;
        this._customerservice.SearchTicketsOnPagination(null, null, null, null, null, null, null, null, null, this.ticketsPageNumber, this.ticketsPageSize, this.ticketsSortColumn, this.ticketsSort, weborderId).subscribe((response: WorkTicket[]) => {
            if (response) {
                this.tickets = response["content"];
                if(response['totalCount']){
                this.ticketsPageCount = response['totalCount'];
                }
            } else {
                this.tickets = [];
                this.ticketsPageCount = 0
            }
        });
    }
        /**
     * sorting of columns // not hits service...
     * @param sortColumn
     */
    sortOrderInformationByColumn(sortColumn: string) {
        let productitems: Array<ProductInformation>;
        productitems = this.orderInformation.productInfo;
        this.isDesc = (this.sortColumn == sortColumn || sortColumn == "") ? !this.isDesc : this.isDesc;
        productitems.sort((a, b) => {
            if (a[sortColumn] > b[sortColumn])
                return this.isDesc ? -1 : 1;

            if (a[sortColumn] < b[sortColumn])
                return this.isDesc ? 1 : -1;
        });
        this.sortColumn = sortColumn;
    }
  /*
    sort dispute tickets by column
     */
    sortTicketsByColumn(sortColumn: string) {
        this.ticketsIsDesc = (this.ticketsSortColumn == sortColumn) ? !this.ticketsIsDesc : this.ticketsIsDesc;
        this.ticketsSort = this.ticketsIsDesc ? "DESC" : "ASC";
        this.ticketsSortColumn = sortColumn;
        //added this condition not to hit service if there are no items in grid.
        if (this.tickets.length === 0) {
            return;
        }
        this.getDisputeTickets();
        this.getOrderNotes();
        this.getOrderLogs();
    }
     /*
    get dispute tickets on page change
     */
    ticketsPageChange(pageNumber: number) {
        if (!isNaN(pageNumber)) {
            this.ticketsPageNumber = pageNumber;
            this.getDisputeTickets();
            this.getOrderNotes();
            this.getOrderLogs();

        }
    }
    /*
      * To update tickets in the order history once updated
    */
   subscribeDisputeTickets() {
    this.messageService.getDisputeTickets().subscribe((data: any) => {
        if (data) {
            this.getDisputeTickets();
            this.getOrderNotes();
            this.getOrderLogs();
        }
    });
   }


   getOrderPaymentInfo(webOrderId : any)
   {
    this._orderService.getRecentOrderInformation(webOrderId).subscribe(tresponse => {
        if (tresponse) {
          this.trackingModel=tresponse.trackingModel;
          if(this.trackingModel){
            for (let [key, value] of Object.entries(this.trackingModel)) {
            if(value){
              this.trackingUrls.push(value);}}
          }
            if (tresponse.id) {
                this._customerservice.getPaymentInfo(webOrderId, tresponse.id).subscribe((response: any) => {
                    if (response) {
                        if (this.orderInformation.billingInfo && this.orderInformation.billingInfo.address) {
                            if (response.billingAddress) {
                                this.orderInformation.billingInfo.address.name = response.billingAddress.name;
                                this.orderInformation.billingInfo.address.addressFirstLine = response.billingAddress.addressLine1;
                                this.orderInformation.billingInfo.address.addressSecondLine = response.billingAddress.addressLine2;
                                this.orderInformation.billingInfo.address.city = response.billingAddress.city;
                                this.orderInformation.billingInfo.address.state = response.billingAddress.state;
                                this.orderInformation.billingInfo.address.zipCode = response.billingAddress.zip
                                    || response.billingAddress.postalCode;
                                this.orderInformation.billingInfo.address.country = response.billingAddress.countryCode;
                            } else {
                                this.orderInformation.billingInfo.address.addressFirstLine = '';
                                this.orderInformation.billingInfo.address.addressSecondLine = '';
                                this.orderInformation.billingInfo.address.city = '';
                                this.orderInformation.billingInfo.address.state = '';
                                this.orderInformation.billingInfo.address.zipCode = '';
                                this.orderInformation.billingInfo.address.country = '';
                            }
                            this.isTitan = true;
                            this.orderInformation.billingInfo.paymentMethod = response.paymentMethod;
                            if (PaymentMethodTypes.Credit_Card === response.paymentMethod) {
                                this.orderInformation.billingInfo.cardHolderName = response.cardHolderName;
                                this.orderInformation.billingInfo.cardType = response.cardType;
                                this.orderInformation.billingInfo.expiryMonth = response.expiryMonth;
                                this.orderInformation.billingInfo.expiryYear = response.expiryYear;
                                this.orderInformation.billingInfo.maskedCard = response.maskedCard;
                            }

                            // if (PaymentMethodTypes.eCheck === response.paymentMethod) {
                            //     this.orderInformation.billingInfo.bankName = response.bankName;
                            //     this.orderInformation.billingInfo.nameOnBankAccount = response.nameOnBankAccount;
                            //     this.orderInformation.billingInfo.accountNumber = response.accountNumber;
                            //     this.orderInformation.billingInfo.email = response.email;
                            //     this.orderInformation.billingInfo.phone = response.phone;
                            //     this.orderInformation.billingInfo.accountType = response.accountType;
                            // }
                            if (PaymentMethodTypes.eCheck === response.paymentMethod) {
                                this.orderInformation.billingInfo.bankName = response.bankName;
                                //this.orderInformation.billingInfo.nameOnBankAccount = response.nameOnBankAccount;
                                this.orderInformation.billingInfo.accountNumber = response.accountNumber;
                                this.orderInformation.billingInfo.email = response.email;
                                this.orderInformation.billingInfo.phone = response.phone;
                                this.orderInformation.billingInfo.accountType = response.accountType;
                            }
                        } else {
                            this.isTitan = false;
                        }
                    }
                }, error => {
                    this.isTitan = false;
                });
            }
        }
    });
   }
   /*create new ticket*/
   createDisputeTicket() {
        if(this.isTicketCreate){
            let ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.fboid;
            ticketTab.isNewTicket = true;
            ticketTab.title = "Create Ticket";
            ticketTab.country = this.orderInfo.homeCountry;
            ticketTab.webOrderID  = this.orderInfo.webOrderID || this.orderInfo.orderID;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }else {
            this.displayAlertbox();
        }
    }
  /*
    view or edit Dispute tickets in new tab
     */
    goToViewTicket(id: any, ticketNumber: any) {
        if (this.isTicketView) {
            let ticketTab = new TicketTabInfo();
            ticketTab.distributorID = this.distributorInfo.distributorId;
            ticketTab.isNewTicket = false;
            ticketTab.ticketID = id;
            ticketTab.title = "View Ticket - " + ticketNumber;
            ticketTab.viewTicket = true;
            this.messageService.setCustomerServiceUserTabContent(ticketTab);
        }
        else {
            this.displayAlertbox();
        }
    }
 /**
    * display alert box if the logged in user do not have permission to see the fbo/retail information
    */
   displayAlertbox() {
    this.deleteModal.toggle = true;
    this.deleteModal.message = CommonMessage.noPermissionMessage;
}
doNotRemoveFormData() {
    //data should not be removed...
}

 /**
     * Get Store Info
     * @param countryCode
     */
    getStoreInfo(countryCode: any) {
        if (countryCode) {
            this.shippingAddressInfoConfig = this._shippingAddressInfoConfigService.getSettings(countryCode);
            this._customerservice.getStoreInfo(countryCode).subscribe(response => {
                if (response) {
                    this.storeInfo = response[0];
                    if (this.orderInformation && this.orderInformation.orderDate) {
                        this.orderInformation.orderDate = moment(this.orderInformation.orderDate.split('T')[0],'YYYY-MM-DD').format('DD-MMM-YYYY');
                    }
                    this.isOrderLoaded = true;
                }
            }, error => {
                const notification: any = this._translatePipe.get('order. Unable to fetch Store Details');
                this._commonService.createNotification('', notification.value, 'error');
            });
        }

    }

    getOrderNotes() {
        if(this.orderInfo && this.orderInfo.webOrderID) {
        this._orderService.getOrderNotes(this.orderInfo.webOrderID).subscribe(response => {
            if (response) {
                  this.orderNotes = response;
                response.forEach((note:any)=>
                   {
                     this._customerservice.getMemberInfo(note.createdBy).subscribe(res => {
                        if (res) {
                            note.name = res.firstName + " " + res.lastName;
                            if (note.createdDate && this.storeInfo) {
                                note.dateFormat = moment(note.createdDate).utcOffset(this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY');
                                note.hoursFormat = moment(note.createdDate).utcOffset(this.storeInfo.timeZoneOffset).format('HH:mm:ss');
                            }
                        }
                    });
                }
               )
            }
        });
        
    }
    }

    getOrderLogs() {
        if(this.orderInfo && this.orderInfo.webOrderID) {
        this._orderService.getOrderLogs(this.orderInfo.webOrderID).subscribe(response => {
            if (response) {
                this.orderLogs = response;
                if (this.orderLogs && this.orderLogs.length > 0) {
                    this.orderLogs.forEach(x => {
                        if (x.date && this.storeInfo) {
                            x.dateFormat = moment(x.date).utcOffset(this.storeInfo.timeZoneOffset).format('DD-MMM-YYYY');
                            x.hoursFormat = moment(x.date).utcOffset(this.storeInfo.timeZoneOffset).format('HH:mm:ss');
                        }
                    });
                }
            }
        });
    }
    }
    /**
     * @description To get the card image
     * @date 2018-08-27
     * @param {*} cardType
     * @returns {string}
     * @memberof PaymentComponent
     */
    getImagePath(cardType: any): string {
        let cardTypeImage;
        if (cardType) {
            switch (true) {
                case cardType.toUpperCase() === PaymentCardTypes.VISA:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/visa.png';
                    break;
                case (cardType.toUpperCase() === PaymentCardTypes.MASTER
                    || cardType.toUpperCase() === PaymentCardTypes.MASTER_WORLDPAY
                    || cardType.toUpperCase() === PaymentCardTypes.MASTERCARD):
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/mastercard.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.AMEX:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/amercianexpress.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.MAESTRO:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/maestro.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DINERS:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/dinner-club.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.JCB:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/jcb.png';
                    break;
                case cardType.toUpperCase() === PaymentCardTypes.DISCOVER:
                    cardTypeImage = environment.uiTemplateBaseUrl + '/images/discovernetwork.png';
                    break;
                default:
                    cardTypeImage = null;
                    break;
            }
        }
        return cardTypeImage;
    }

  getShippingTrackURL(webOrderId : any)
   {
       if(webOrderId){
        this._orderService.getShippingTrackingURL(webOrderId).subscribe(response => {
            if (response) {
                this.shipTrackingUrl = response.shipmentTrackingUrl;
            }
        });
       }
   }

   /**
     *
     * @param items
     */
    getItemVolumeSum(items): number {
        return items
            .map(function (x) { return x.taxAmount; })
            .reduce(function (a, b) { return a + b; });
    }
    trackByItem(index: number): number {
        return index;
    }

   
}



// WEBPACK FOOTER //
// ./src/app/customerservice/components/order-view.component.ts